export default __webpack_public_path__ + "static/media/check.f67ae484.svg";